import React, { Component } from "react";
import _ from "lodash";
import TimeStamp from "react-timestamp";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// React-bootstrap
import { Button } from "react-bootstrap";
// No Data Found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { doGetLocklist, fire, auth } from "../../firebase/index";
import axios from "axios";
import "../../routes/app";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

import { customLog } from "../../variables/Variables";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import NotificationLogs from "./NotificationLogs";
import ActivityLogs from "./ActivityLogs";

import notificationStatus from "assets/img/notificationStatus.png";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";

import LocalizedStrings from "react-localization";
import { isSuper } from "@babel/types";
let localizationStrings = new LocalizedStrings({
  en: {
    activityLogsTitle: "Notifications/Activity",
    activityLogsDescription: "Notifications & Activities records",
    requestTitle: "Requests",
    notificationNavigation: "Notifications",
    activityNavigation: "Activities",
  },
  ja: {
    activityLogsTitle: "通知／履歴",
    activityLogsDescription: "通知＆通知履歴",
    requestTitle: "リクエスト",
    notificationNavigation: "通知",
    activityNavigation: "履歴",
  },
  es: {
    activityLogsTitle: "Notificaciones/Actividad",
    activityLogsDescription: "Registros de Notificaciones y Actividades",
    requestTitle: "Solicitudes",
    notificationNavigation: "Notificaciones",
    activityNavigation: "Actividades",
  },
});

class activityLogs extends Component {
  constructor(props) {
    super(props);
    this.showNotification = this.showNotification.bind(this);

    this.state = {
      isSuperAdmin: false,
      loading: true,
      _notificationSystem: null,
      currentAllowAccessState: false,
      notifStatus: false,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    fire.database().ref("userLocks");

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      // check if there is unread notifications
      fire
        .database()
        .ref("individualNotifications")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((Log) => {
              let Logval = Log.val();

              if (!Logval.isRead) {
                this.setState({
                  notifStatus: true,
                });
              }
            });
          }
        });
    }

    // Check for superadmin status
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();
            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;
              const superAdminStatus = eachMemberDetails.isSuperAdmin;

              if (
                eachMemberEmail === auth.currentUser.email &&
                superAdminStatus
              ) {
                this.setState({
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                });
              }
            }
          });
        }
      });
  }

  // Will use showNotification after approving or denying requests in Requests tab
  showNotification(msg, lvl) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: 3,
    });
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    // check if user is Super Admin
    // if(this.state.isSuperAdmin){
    return (
      <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="header">
          <h2>{localizationStrings.activityLogsTitle}</h2>
          <h4>{localizationStrings.activityLogsDescription}</h4>
        </div>
        <br />

        <div>
          <Tabs forceRenderTabPanel defaultIndex={0}>
            <TabList>
              <Tab>
                {localizationStrings.notificationNavigation}
                {this.state.notifStatus === true ? (
                  <img
                    style={{
                      height: "10px",
                      width: "10px",
                      marginLeft: "10px",
                    }}
                    src={notificationStatus}
                    alt="notificationStatus"
                  />
                ) : (
                  ""
                )}
              </Tab>
              <Tab>{localizationStrings.activityNavigation}</Tab>
            </TabList>

            {/* Notification panel */}
            <TabPanel>
              <NotificationLogs />
            </TabPanel>

            {/* Activity panel */}
            <TabPanel>
              <ActivityLogs />
            </TabPanel>
          </Tabs>
          {/* <Chatbot/> */}
        </div>
      </div>
    );
    // } else {
    //   return (
    //     <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
    //       <NotificationSystem ref="notificationSystem" style={style} />
    //       <div className="header">
    //         <h2>{localizationStrings.activityLogsTitle}</h2>
    //         <h4>{localizationStrings.activityLogsDescription}</h4>
    //       </div>
    //       <br />

    //       <div>
    //         <Tabs forceRenderTabPanel defaultIndex={0}>
    //           <TabList>
    //             <Tab>{localizationStrings.notificationNavigation}</Tab>
    //           </TabList>

    //           {/* Notification panel */}
    //           <TabPanel>
    //             <NotificationLogs />
    //           </TabPanel>

    //         </Tabs>
    //       </div>
    //     </div>
    //   );
    // }
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(activityLogs);
